import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { get_analytics_data } from "../../../reduxData/user/userAction";

const useAnalyticsData = () => {
  const dispatch = useDispatch();
  const { analyticsData } = useSelector((state) => state.user);
  const today = new Date().toISOString().split("T")[0];

  const [date, setDate] = useState({
    start_date: "",
    end_date: "",
  });

  const handleStartDateChange = useCallback((e) => {
    setDate((prev) => ({ ...prev, start_date: e.target.value }));
  }, []);

  const handleEndDateChange = useCallback((e) => {
    setDate((prev) => ({ ...prev, end_date: e.target.value }));
  }, []);

  const fetchData = useCallback(async () => {
    const start = date?.start_date;
    const end = date?.end_date;
    if (start > end) {
      toast.error("Start Date can not be before End Date");
      return;
    }
    await get_analytics_data(
      localStorage.getItem("token"),
      dispatch,
      start,
      end
    );
  }, [date, dispatch]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFilterApplied = Boolean(date?.start_date || date?.end_date);

  return {
    analyticsData,
    date,
    today,
    isFilterApplied,
    handleStartDateChange,
    handleEndDateChange,
    fetchData,
  };
};

export default useAnalyticsData;
